export const ERRORS = {
  NO_INVENTORY: 'noInventory',
  INVALID_CHARACTERS: 'invalidCharacters',
  INVALID_MIN: 'invalidMin',
  INVALID_MAX: 'invalidMax',
  INVALID_DISCOUNT: 'invalidDiscount',
  NEGATIVE_DISCOUNT: 'negativeDiscount',
  INVALID_MIN_RETURN_QUANTITY: 'invalidMinReturnQuantity',
  INVALID_MAX_RETURN_QUANTITY: 'invalidMaxReturnQuantity',
  INVALID_UNREFERENCED_RETURN: 'invalidUnreferencedReturn',
}
